import Swiper, {
  Navigation,
  Pagination,
  FreeMode,
  Thumbs,
  Autoplay,
  EffectFade,
} from 'swiper';
import { throttle } from 'throttle-debounce';
import safeJSONParse from '../utils/safeJSONParse';
import lazyloadify from '../global/lazyload';

const MOBILE_BREAKPOINT = 768;

/**
 * Standard Swiper instantiation
 */
export const swipify = () => {
  const swipers = document.querySelectorAll('[data-swiper]');
  const thumbSwipers = [];

  if (!swipers.length) return;

  window.blubolt.swiperObjects = [];

  swipers.forEach((swiper) => {
    const slides = swiper.querySelectorAll('.swiper-slide');
    let config = swiper.dataset.swiperConfig
      ? safeJSONParse(swiper.dataset.swiperConfig, false)
      : {};
    const mods = [];
    !config ? console.error('Error in Swiper JSON') : null;
    if (slides.length && config) {
      // The way Swiper works is that it loads 'modules'
      // Here we're looking for a reference to the module in the config
      // If it's there we add it to the mods array
      if ('navigation' in config) {
        mods.push(Navigation);
      }
      if ('pagination' in config) {
        mods.push(Pagination);
      }
      if ('freeMode' in config) {
        mods.push(FreeMode);
      }
      if ('autoplay' in config) {
        mods.push(Autoplay);
      }
      if (config.effect === 'fade') {
        mods.push(EffectFade);
      }
      if ('thumbs' in config) {
        mods.push(Thumbs);
        thumbSwipers.forEach((thumbSwiper) => {
          config = { ...config, ...{ thumbs: { swiper: thumbSwiper } } };
        });
      }
      // We then add the modules to the config
      config = { ...config, ...{ modules: mods } };

      swiper.classList.add('swiper--active');
      const newSwiper = new Swiper(swiper, config);
      // If the swiper is for thumbs we push it to the thumbSwipers array
      if (swiper.dataset.swiperThumbs) {
        thumbSwipers.push(newSwiper);
      }

      // Pagination as a "progress bar" does not allow for on click, so we have manually done it here.
      if (swiper.hasAttribute('data-progress-pagination')) {
        // Listen for a click event on the pagination element, calculate the clicked position
        // as a percentage of the total width, and split it among the slides.
        // Adjust the slide index to ensure the first slide is represented as 1, not 0,
        // then use Swiper's `slideTo` method to move to the selected slide.
        // Note: We filter out duplicate slides on looped swipers to prevent going past the pagination limit.
        const paginationElement = swiper.querySelector('.swiper-pagination');

        // paginationElement.addEventListener('click', (e) => {
        //   // Get clicked position by width
        //   const clickedPosition =
        //     e.clientX - paginationElement.getBoundingClientRect().left;
        //   const totalWidth = paginationElement.offsetWidth;
        //   const clickedPercentage = (clickedPosition / totalWidth) * 100;

        //   // Count only the slides that do not have the "swiper-slide-duplicate" class
        //   const nonDuplicateSlides = Array.from(newSwiper.slides).filter(
        //     (slide) => !slide.classList.contains('swiper-slide-duplicate')
        //   );

        //   // This sets the active slide.
        //   const activeRange = 100 / nonDuplicateSlides.length;
        //   const slideIndex = Math.floor(clickedPercentage / activeRange + 1);

        //   newSwiper.slideTo(slideIndex);
        // });
      }

      lazyloadify();
      window.blubolt.swiperObjects.push(newSwiper);
    }
  });
};

/**
 * Instantiate swipers for mobile only
 */
export const swipifyMob = () => {
  const swipers = document.querySelectorAll('[data-swiper-mob]');

  if (!swipers.length) return;

  window.blubolt.swiperMobileObjects = [];

  const initSwiperOnMobile = () => {
    // TODO: Swap less than
    if (window.innerWidth < MOBILE_BREAKPOINT) {
      swipers.forEach((swiper) => {
        const slides = swiper.querySelectorAll('.swiper-slide');
        let config = swiper.dataset.swiperConfig
          ? safeJSONParse(swiper.dataset.swiperConfig, false)
          : {};
        const mods = [];
        !config ? console.error('Error in Swiper JSON') : null;
        if (slides.length && config) {
          if ('navigation' in config) {
            mods.push(Navigation);
          }
          if ('pagination' in config) {
            mods.push(Pagination);
          }
          if ('freeMode' in config) {
            mods.push(FreeMode);
          }
          if ('thumbs' in config) {
            mods.push(Thumbs);
          }

          config = { ...config, ...{ modules: mods } };
          swiper.classList.add('swiper--mob-active');
          const newSwiper = new Swiper(swiper, config);
          lazyloadify();
          window.blubolt.swiperMobileObjects.push(newSwiper);
        }
      });
    } else {
      if (window.blubolt.swiperMobileObjects) {
        const keys = Object.keys(window.blubolt.swiperMobileObjects);
        keys.forEach((key) =>
          window.blubolt.swiperMobileObjects[key].destroy()
        );
        window.blubolt.swiperMobileObjects = [];
      }
    }
  };

  initSwiperOnMobile();
  window.addEventListener(
    'resize',
    throttle(500, false, () => initSwiperOnMobile())
  );
};

export default swipify;
